import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire/compat';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Thrid Party Module
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

// Material
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

// Thrid Party Material
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Component
import { AppComponent } from './views/app.component';
import { LoginComponent, LoginDesktopComponent, LoginMobileComponent } from './views/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { LandingComponent } from './views/landing/landing.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { CloseDayProcessComponent } from './views/closeday-process/closeday-process.component';
import { PreviewReportComponent } from './views/preview-report/preview-report.component';
import { SearchPipe } from './search.pipe';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { InterceptorService } from './services/interceptor/interceptor.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule, DatePipe } from '@angular/common';

import { APP_ENVIRONMENT } from "@easyfo/common-lib";
import { ToolbarSidebarModule } from "@easyfo/toolbar";
import { UserProfileModule } from '@easyfo/user-profile';
import { EmailVerificationComponent } from './views/verification/verification';

export function HttpLoaderFactory(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: "./assets/i18n/", suffix: ".json" },
    { prefix: "toolbar/assets/i18n/", suffix: ".json" },
    { prefix: "user-profile/assets/i18n/", suffix: ".json" }
  ]);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent, LoginDesktopComponent, LoginMobileComponent, 
    EmailVerificationComponent,
    RegisterComponent,
    LandingComponent,
    NotFoundComponent,
    CloseDayProcessComponent,
    PreviewReportComponent,
    SearchPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaV3Module,
    AngularFireModule.initializeApp(environment.firebase),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatCardModule,
    MatIconModule,
    NgbModule,
    UserProfileModule.forRoot(environment),
    ToolbarSidebarModule.forRoot(environment)
  ],
  providers: [
    DatePipe,
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.reCAPTCHA.publicKey },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: APP_ENVIRONMENT, useValue: environment }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }